"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingOptions = void 0;
const core_1 = require("@material-ui/core");
const classnames = require("classnames");
const icons_1 = require("client/components/icons");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const store_1 = require("client/modules/app-settings/store");
const app_settings_1 = require("shared/app-settings");
const select_1 = require("client/components/material/select");
const styles = core_1.createStyles({
    button: {
        boxShadow: "none",
        height: "50px",
        width: "auto !important"
    },
    checkbox: {},
    defaultAccent: {
        background: "#18c27336"
    },
    header: {},
    input: {
        alignItems: "center",
        display: "flex",
        marginBottom: ".5rem"
    },
    label: {
        flex: "1 1 400px !important"
    },
    list: {},
    removeButton: {
        flex: "0 0 25px !important"
    },
    root: {},
    select: {
        width: "100%"
    }
});
const decorate = core_1.withStyles(styles);
let ShippingOptionsUnstyled = class ShippingOptionsUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.shippingMethod = "";
        this.shippingOptionsList = [];
        this.initializeShippingOptions = () => {
            this.shippingOptionsList =
                (this.props.distributor && this.props.distributor.shippingOptions) || [];
        };
        this.resetText = () => {
            this.shippingMethod = "";
        };
        this.handleShippingMethodChange = (event, value) => {
            this.shippingMethod = value;
        };
        this.handleRemoveShippingOption = (index) => (event) => {
            event.stopPropagation();
            this.shippingOptionsList.splice(index, 1);
            this.props.distributor.shippingOptions = this.shippingOptionsList;
        };
        this.sortedShippingOptionsList = () => this.shippingOptionsList.sort((a, b) => {
            const globalOptions = (this.distributorShippingMethodSetting &&
                this.distributorShippingMethodSetting.value &&
                this.distributorShippingMethodSetting.value.split(",")) ||
                [];
            const globalOptionsMapped = globalOptions.map((option, index) => [
                index,
                option
            ]);
            const foundFromGlobalA = globalOptionsMapped.find(meta => {
                const [index, option] = meta;
                option === a.method;
            });
            const foundFromGlobalB = globalOptionsMapped.find(meta => {
                const [index, option] = meta;
                option === b.method;
            });
            if (foundFromGlobalA && foundFromGlobalB) {
                return Number(foundFromGlobalA[0]) - Number(foundFromGlobalB[0]);
            }
            return a.method > b.method ? 1 : -1;
        });
        this.handleAddShippingOption = (value) => {
            const shippingMethodMeta = {
                isDefault: !this.shippingOptionsList.length,
                method: value
            };
            this.shippingOptionsList.push(shippingMethodMeta);
            this.shippingOptionsList = this.sortedShippingOptionsList();
            this.props.distributor.shippingOptions = this.shippingOptionsList;
        };
        this.handleDefaultSelect = (method) => () => {
            this.shippingOptionsList.map(option => {
                option.isDefault = option.method === method;
                return option;
            });
        };
        this.renderShippingOptionsList = () => {
            const { classes } = this.props;
            if (!this.shippingOptionsList || !this.shippingOptionsList.length) {
                return [];
            }
            return this.shippingOptionsList.map(({ method, isDefault }, index) => (React.createElement(list_item_1.MaterialListItem, { key: index, onClick: this.handleDefaultSelect(method), className: classnames({ [classes.defaultAccent]: isDefault }) },
                React.createElement(list_item_text_1.MaterialListItemText, { className: classes.checkbox, primary: React.createElement(checkbox_1.MaterialCheckbox, { checked: isDefault, label: "", onAction: this.handleDefaultSelect(method) }) }),
                React.createElement(list_item_text_1.MaterialListItemText, { className: classes.label, primary: method }),
                React.createElement(list_item_text_1.MaterialListItemText, { className: classes.removeButton, primary: React.createElement(core_1.Typography, { onClick: this.handleRemoveShippingOption(index) },
                        React.createElement(icons_1.CloseIcon, null)) }))));
        };
    }
    get availableOptions() {
        if (!this.distributorShippingMethodSetting) {
            return null;
        }
        const shippingOptions = this.distributorShippingMethodSetting.value.split(",");
        return shippingOptions
            .filter(option => !this.shippingOptionsList.find(shippingOption => shippingOption.method === option))
            .map((option, index) => ({
            id: index,
            label: option,
            value: option
        }));
    }
    async componentDidMount() {
        const setting = await store_1.appSettingsStore.readSettings(app_settings_1.AppOption.ShippingMethod);
        this.distributorShippingMethodSetting = setting;
        this.initializeShippingOptions();
    }
    componentWillReceiveProps() {
        this.initializeShippingOptions();
    }
    render() {
        const { classes } = this.props;
        return (React.createElement("div", { className: classes.root },
            React.createElement("div", { className: classes.header },
                React.createElement(core_1.Typography, { variant: "title", gutterBottom: true }, "Shipping Options")),
            React.createElement("div", { className: classes.input },
                React.createElement(select_1.MaterialSelect, { className: classes.select, options: this.availableOptions, searchable: true, label: "Available Shipping Options", onSelect: this.handleAddShippingOption, value: "" })),
            React.createElement("div", { className: classes.list }, this.renderShippingOptionsList())));
    }
};
__decorate([
    mobx_1.observable
], ShippingOptionsUnstyled.prototype, "shippingMethod", void 0);
__decorate([
    mobx_1.observable
], ShippingOptionsUnstyled.prototype, "shippingOptionsList", void 0);
__decorate([
    mobx_1.observable
], ShippingOptionsUnstyled.prototype, "distributorShippingMethodSetting", void 0);
__decorate([
    mobx_1.computed
], ShippingOptionsUnstyled.prototype, "availableOptions", null);
ShippingOptionsUnstyled = __decorate([
    mobx_react_1.observer
], ShippingOptionsUnstyled);
exports.ShippingOptions = decorate(ShippingOptionsUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/distributors/components/distributor-list/components/shipping-options/shipping-options.tsx
// module id = 3521
// module chunks = 0